export default __webpack_public_path__ + "static/media/EverydayCircusTwo.d30fafe0.jpg";